import clsx from 'clsx'
import { ComponentProps, CSSProperties, ElementType, forwardRef, ReactNode, Ref } from 'react'

import cl from './Text.module.scss'

type TextOwnProps<E extends ElementType> = {
	as?: E
	children?: ReactNode
	size?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11'
	weight?: 'regular' | 'medium' | 'semibold' | 'bold'
	color?: string
}
type TextProps<E extends ElementType> = TextOwnProps<E> & Omit<ComponentProps<E>, keyof TextOwnProps<E>>

type TextComponent = <E extends ElementType = 'p'>(props: TextProps<E> & { ref?: Ref<Element> }) => JSX.Element | null

export const Text: TextComponent = forwardRef(function Text<E extends ElementType = 'p'>(
	props: TextProps<E>,
	ref: Ref<Element>
) {
	const { children, as, size, weight, className, color, ...rest } = props

	const Component = as ?? 'p'

	const rootClassess = clsx(className, {
		[cl[`size-${size}`]]: size,
		[cl[`weight-${weight}`]]: weight
	})

	const restProps = rest as ComponentProps<E> & { style?: CSSProperties }
	const mergedStyle: CSSProperties | undefined = { ...(restProps.style || {}), ...(color ? { color } : {}) }

	return (
		<Component ref={ref} className={rootClassess} {...restProps} style={mergedStyle} data-ui-new>
			{children}
		</Component>
	)
}) as TextComponent
